import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  FormHeader,
  InputBox,
  TabComponent,
} from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import Sinhala from "./sinhala";
import English from "./english";

import { Store } from "react-notifications-component";
import { useDispatch, useSelector } from "react-redux";
import { clearselectedLiveFeed } from "../../news/redux/actions";
import TagsSelectBox from "../../templates/tagsSelectBox";
import { openCreateTagModal } from "../../Tags/redux/actions";
import {
  createNewLiveFeed,
  updateLiveFeed,
} from "../../liveFeed/service/liveFeed.service";
import { clearSelectFeed } from "../../liveFeed/redux/actions";
import { set } from "immutable";

const CreateNewLiveFeed = (props) => {
  // const dispatch = useDispatch();
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [finish, setFinish] = useState(true);
  const [language, setLanguage] = useState("si");
  const [useLanguage, setUseLanguage] = useState("si");
  const [selectTagList, setSelectTagList] = useState([]);
  const [formData, setFormData] = useState({
    descriptionSI: {
      key: "descriptionSI",
      label: "Description (SI)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },

    descriptionEN: {
      key: "descriptionEN",
      label: "Description (EN)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    url: {
      key: "url",
      label: "URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [imageGallery, setImageGallery] = useState([]);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const selectedLiveFeed = useSelector(
    (state) => state.liveFeedReducer.selectedLiveFeed
  );

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }

    setFinish(true);
    setSelectTagList([]);
    setFormData(updateForm);
    props.refresh(true);
  };

  const onClickSave = async () => {
    setIsLoading(true);
    setIsButtonDisabled(false);

    const updateForm = {
      ...formData,
    };

    let body = {
      title: {
        si: updateForm.descriptionSI.value,
        en: updateForm.descriptionEN.value,
      },
      author: "Damith",
      url: updateForm.url.value,
      tags: selectTagList,
      status: "Draft",
      language: useLanguage,
    };

    const response = await createNewLiveFeed(body);
    console.log("live feed body::", body);
    try {
      if (response?.data) {
        Store.addNotification({
          title: "Success!",
          message: "Live Feed Create Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        setIsButtonDisabled(true);
        setFinish(true);
        clearAll();
      }
    } catch (error) {
      console.error("Error creating live feed:", error);
      Store.addNotification({
        title: "Error!",
        message: "Error creating Live Feed",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 2000,
          onScreen: true,
        },
      });
      setIsLoading(false);
      // setIsButtonDisabled(true);
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    setIsButtonDisabled(false);
    console.log("selectedLiveFeed::", selectedLiveFeed);
    if (selectedLiveFeed?.news_id) {
      const updateForm = {
        ...formData,
      };

      let body = {
        title: {
          si: updateForm.descriptionSI.value,
          en: updateForm.descriptionEN.value,
        },
        author: "Damith",
        url: updateForm.url.value,
        tags: selectTagList,
        status: "Draft",
        language: useLanguage,
      };

      console.log("live feed update body::", body);
      try {
        const response = await updateLiveFeed(body, selectedLiveFeed?.news_id);
        console.log("response::", response);
        if (response?.data) {
          Store.addNotification({
            title: "Success!",
            message: "Live Feed Update Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setIsButtonDisabled(true);
          // setFinish(true);
          clearAll();
          dispatch(clearSelectFeed());
        }
      } catch (error) {
        console.error("Error updating live feed: ", error);
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Error creating Live Feed",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        setIsLoading(false);
      }
    }
  };

  const updateForm = { ...formData };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const tagsSelect = (tags) => {
    console.log({ tags });
    setSelectTagList(tags);
  };

  const onChangeSI = (form) => {
    if (form) {
      setFormData({
        ...formData,
        descriptionSI: form.descriptionSI,
      });
      setFinish(false);
    }
  };

  const onChangeEN = (form) => {
    if (form) {
      setFormData({
        ...formData,
        descriptionEN: form.descriptionEN,
      });
      setFinish(false);
    }
  };

  const onChange = (key) => {
    console.log(key);
    setLanguage(key);
  };
  const items = [
    {
      key: "si",
      label: "Sinhala",
      children: <Sinhala finish={finish} onChange={onChangeSI} />,
    },
    {
      key: "en",
      label: "English",
      children: <English finish={finish} onChange={onChangeEN} />,
    },
  ];

  useEffect(() => {
    clearAll();
    dispatch(clearSelectFeed());
  }, []);

  useEffect(() => {
    if (selectedLiveFeed?.news_id) {
      let updateFormData = { ...formData };
      updateFormData.descriptionSI.value = selectedLiveFeed?.title["si"];
      updateFormData.descriptionEN.value = selectedLiveFeed?.title["en"];
      updateFormData.url.value = selectedLiveFeed?.url || "";
      setUseLanguage(selectedLiveFeed?.language);
      setSelectTagList(selectedLiveFeed?.tags || []);
      setFormData(updateFormData);
    } else {
      clearAll();
    }
  }, [selectedLiveFeed]);

  return (
    <>
      <div className="hne-create-feed-wrapper">
        <FormHeader
          data={{
            formHeader: "Create New Live Feed",
            size: "md-md",
          }}
        />
        <>
          <TabComponent items={items} onChange={onChange} />
        </>
        <div className={"hne-cfw-youtube"}>
          <div className="d-flex flex-row align-items-center justify-content-between mb-3">
            <InputBox
              data={updateForm.url}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(e.target.value, updateForm.url.key);
              }}
            />
          </div>

          <div
            className="d-flex justify-content-end align-items-end mt-2"
            style={{
              marginBottom: "-25px",
              position: "relative",
              zIndex: "90",
            }}
          >
            <Button
              data={{
                btnName: "Create New",
                buttonType: "secondary s-border",
                buttonSize: "xs x",
                // isLoading: isLoading,
              }}
              onClick={(e) => {
                dispatch(openCreateTagModal());
              }}
            />
          </div>

          <TagsSelectBox
            onChangeTag={tagsSelect}
            tagList={selectTagList}
            data={{
              language: language,
            }}
          />
        </div>
      </div>

      <div
        className="d-flex flex-row justify-content-between"
        style={{ marginBottom: "15px" }}
      >
        {selectedLiveFeed?.news_id && (
          <Button
            data={{
              btnName: "Clear",
              buttonType: "secondary mr-2",
              buttonSize: "lg",
              isLoading: isLoading,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectedLiveFeed?.news_id) {
                dispatch(clearSelectFeed());
                setFinish(true);
                setUseLanguage("si");
                const updateForm = {
                  ...formData,
                };
                for (let key in updateForm) {
                  updateForm[key].value = "";
                  updateForm[key].isValid = false;
                  updateForm[key].touched = false;
                }
                setFormData(updateForm);
              }
            }}
          />
        )}
        <Button
          data={{
            btnName: selectedLiveFeed?.news_id ? "Update" : "Done",
            buttonType:
              updateForm.descriptionSI.value === "" &&
              updateForm.descriptionEN.value === ""
                ? "primary disabled"
                : "primary",
            buttonSize: "lg",
            isLoading: isLoading,
            disable:
              updateForm.descriptionEN.value === "" &&
              updateForm.descriptionSI.value === ""
                ? true
                : false,
          }}
          onClick={async (e) => {
            e.preventDefault();
            if (selectedLiveFeed?.news_id) {
              await onClickUpdate(e);
            } else {
              await onClickSave(e);
            }
          }}
        />
      </div>
    </>
  );
};
export default withRouter(CreateNewLiveFeed);
